import * as Immutable from 'immutable';
import * as React from 'react';

import { addModifiers } from '../../shared/helpers';

import { FlashMessage } from './FlashMessage';
import { FlashMessageLinkHandlers } from './FlashMessages';

interface FlashMessagesContentProps {
  modifiers: string[];
  type: string;
  index: number;
  handlerCloseFlash: () => void;
  links: any;
  messages: any;
  intl: any;
  inputType: any;
  needIntl: boolean;
  props: any;
  excludedLinks: Immutable.List<number>;
  showCloseButton: boolean;
  parseHtml: boolean;
  linkHandlers?: FlashMessageLinkHandlers;
}

export const FlashMessagesContent = ({
  modifiers,
  type,
  index,
  handlerCloseFlash,
  messages,
  links,
  needIntl,
  inputType,
  intl,
  excludedLinks,
  showCloseButton,
  parseHtml,
  props,
  linkHandlers,
}: FlashMessagesContentProps) => (
  <div className={addModifiers('flash-messages', modifiers.concat([type]))} key={`flash-messages-${index}`}>
    <div className="flash-messages__content">
      <ul className="flash-messages__list">
        <FlashMessage
          messages={messages}
          links={links}
          needIntl={needIntl}
          inputType={inputType}
          intl={intl}
          props={props}
          type={type}
          excludedLinks={excludedLinks}
          parseHtml={parseHtml}
          linkHandlers={linkHandlers}
        />
      </ul>
    </div>
    {showCloseButton && <div className="flash-messages__close" onClick={handlerCloseFlash} />}
  </div>
);
